var INTEGER_TYPE = 'Argument was not an integer';
var NUMBER_TYPE = 'Argument was not a number';
var MIN_MAX = 'Max is not greater than min. Did you input a single negative number?';
export { INTEGER_TYPE, NUMBER_TYPE, MIN_MAX };